// export const baseURL = "http://192.168.1.188:9093";
export const baseURL = "https://leads.appvedas.com/";



export const imageURL = (img) => {
    // return `${baseURL}${img}`
    return `${img}`
}

export const ENDPOINTS = {
    main_header: "/main-header-api/",
    header: "/header-api/",
    sub_header: "subheader-api/",
    business_type_list: "/business-type-api/",
    seller_list_api: "/related-brand-api/",
    products: "/all-product-list-admin-api/",
    product_type: "/admin-edit-products-type-api/",
    product_status: "/admin-product-enable-disable-api/",
    seller_list: "/seller-list-admin-api/",
    seller_list_forlead: "/seller-list-for-add-lead-admin-api/",
    seller_enable_disable: '/admin-seller-enable-disable-api/',
    blog_category_api: '/blog-category-api/',
    blog_sub_category_api: '/blog-subcategory-api/',
    blog_api: '/blog-api/',
    news_api: '/news-api/',
    faq_api: '/faq-api/',
    banner_api: '/banner-api/',
    slider_api: '/slider-api/',
    event_api: '/event-api/',
    login_api: "/super-admin-login-api/",
    testimonial_api: "/testimonial-api/",
    plan_type: "/plantype-api/",
    module_api: "/planmodule-api/",
    plan: "/plan-api/",
    Direct_lead: "/admin-create-direct-lead-api/",
    category_Api: "/sub-sub-category-api/",
    admin_lead: "/admin-create-lead-api/",
    customer_need: "/your-need-api/",
    tradeshow: "/upcoming-trade-show-api/",
    exhibtion: "/exhibition-api/",
    customer_requirement: "/admin-customer-requirement-api/",
    sellonleadIndia: "/shell-on-lead-india-upload-product-api/",
    category: "/category-api/",
    subcategory: "/sub-category-api/",
    subsubcategory: "/sub-sub-category-api/",
    metapages: "/meta-pages-api/",
    metadetail: "/meta-pages-details-api/",
    page_ui: "/page-design-setup-api/"

}
